import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useEducationSectionStyles = makeStyles()((theme: Theme) => ({
  card: {
    boxShadow: "0 0 10px rgb(0 0 0 / 0.3)",
    borderRadius: "5px",
  },
  sectionTitle: {
    textAlign: "start",
    color: theme.palette.info.dark,
    textTransform: "uppercase",
    fontWeight: "bold",
    marginBottom: "1rem",
  },
  inputContainer: {
    marginBottom: "1rem",
  },
  inputTitle: { color: theme.palette.info.dark, textAlign: "start" },
  radioButton: {
    marginLeft: "15px",
    "&.MuiRadio-root": {
      color: theme.palette.info.dark,
    },
    "&.Mui-checked": {
      color: theme.palette.info.dark,
      "& svg": {
        color: theme.palette.info.dark,
      }
    },
  },
  radioButtonTitle: {
    color: theme.palette.info.dark,
  },
  input: {
    borderRadius: "5px",
    height: "2rem",
    marginRight: "5px",
    backgroundColor: "transparent"
  },
  formControl: {
    "& .MuiOutlinedInput-root.Mui-focused": {
      "& > fieldset": {
        borderColor: theme.palette.info.dark,
      },
    },
  },
}));
